import { createApi } from "@reduxjs/toolkit/query/react";
import { createCustomFetchBaseQuery } from "../baseQuery";
import { updateProfile } from "firebase/auth";

export const authApi = createApi({
  reducerPath: "auth",
  baseQuery: createCustomFetchBaseQuery(),
  endpoints: (builder) => ({
   
    login: builder.mutation({
      query: (login) => ({
        url: `/admin/login`,
        method: "POST",
        headers: { 'x-admin-access-token': process.env.REACT_APP_LOGIN_TOKEN },
        body: login,
      }),
    }),

    register: builder.mutation({
      query: (register ) => ({
        url: `/auth/signup`,
        method: "POST",
        // headers: { "Content-Type": "multipart/form-data" },
        body: register,
      }),
    }),

    changePassword: builder.mutation({
      query: (data) => ({
        url: `/admin/changepassword`,
        method: "PUT",
        body: data,
      }),
    }),

    verifyEmail: builder.mutation({
      query: (data) => ({
        url: `/auth/verify`,
        method: "POST",
        body: data,
      }),
    }),

    forgotPassword: builder.mutation({
      query: (data) => ({
        url: `/auth/forgotpassword`,
        method: "POST",
        body:data,
      }),
    }),
    
    updateProfile: builder.mutation({
      query: (data) => ({
        url: `/admin/updateprofile`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ['auth'],
     }),

     getUserProfile: builder.query({
      query: () => ({
        url: `/admin/profile`,
        method: "GET",
      }),
      transformResponse: (res) => res.body,
      providesTags: ['auth'],
     }),

     getPrivacyPolicy: builder.query({
      query: () => ({
        url: `/auth/privacypolicy`,
        method: "GET",
      }),
      transformResponse: (res) => res?.body,
     })
  })
});

export const {
 useForgotPasswordMutation,useLoginMutation,useRegisterMutation,useChangePasswordMutation,useVerifyEmailMutation, useUpdateProfileMutation , useGetUserProfileQuery, useGetPrivacyPolicyQuery
} = authApi;